import React, { useState, useEffect, useCallback, useRef } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid,
  MenuItem,
  TextField,
  InputAdornment
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";
import { useFormik, useField } from "formik";
import { useDropzone } from "react-dropzone";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import * as yup from "yup";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import moment from "moment";

//Services
import LocationApi from "Services/Location";
import ImageUploadApi from "Services/ImageUpload";
import PassengerApi from "Services/Passenger";

//DropZone
// import DropZone from "./DropZone";

//Constants
import { CUSTOM_CONSTANTS } from "../../../../Constants";

//Data
import countryCodeData from "./data/countryCode/index.json";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PassengerCreate = (props) => {
  const { openDialog, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [passengerimage , setpassengerimage]= useState("/assets/images/user/avatar.png");
  //pagination

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState("unlimited");

  // Max file size
  const maxFileSize = 5242880;
  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };
  // File length validator
  const fileLengthValidator = (file) => {
    if (file.size > maxFileSize) {
      alert(`File size is larger than ${formatBytes(maxFileSize)}`);
      return {
        code: "file-too-large",
        message: `File size is larger than ${formatBytes(maxFileSize)}`,
      };
    }
    return null;
  };

  // Dropzone props
  const { getRootProps, getInputProps, open } = useDropzone({
    noClick: true,
    noKeyboard: true,
    maxSize: formatBytes(maxFileSize),
    maxFiles: 1,
    accept: "image/*",
    validator: fileLengthValidator,
    onDrop: (acceptedFiles) => {
      let fileLength = acceptedFiles.map((file) => file.size);
      if (acceptedFiles && fileLength < maxFileSize) {
        const file = acceptedFiles[0];
  
        // Convert file to Base64
        const reader = new FileReader();
        reader.onload = () => {
          const base64String = reader.result;
          formik.setFieldValue("passengerProfileImage", file); // Keep the file for form submission
          setpassengerimage(base64String); // Set the Base64 string for preview
        };
        reader.onerror = (error) => {
          console.error("Error converting file to Base64:", error);
        };
        reader.readAsDataURL(file); // Convert file to Base64
      }
    },
  });

  const handleAddPassengers = (formValues) => {
    dispatch(showLoader("Loading please wait..."));

    let validatationPass = true;

    const data = {
      firstName: formValues?.firstName,
      lastName: formValues?.lastName,
      country: formValues?.country,
      countryCode: formValues?.countryCode,
      mobileNumber: formValues?.mobile,
      email: formValues?.email,
      image: formValues?.passengerProfileImage,
      password: formValues?.password,
      passConfirmation: formValues?.passConfirmation,
      gender: formValues?.gender,
      customField1: formValues?.customField1,
      customField2: formValues?.customField2,
    };
    
   // console.log('data--->',data);
   // return false;
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Passenger Created Successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );

        //console.log("the response data ", res?.data);
        // setProfileDetails([]);
        formik.resetForm();
        setpassengerimage("/assets/images/user/avatar.png");
        handleClose();
        // getProfileDetails();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while create passenger",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("update profile details api", err);
    };

    if (validatationPass) {
      PassengerApi.addPassengers({ ...data }).then(onSuccess, onFailure);
    }
  };

  // Formik
  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      passConfirmation: "",
      gender: "",
      country: "",
      mobile: "",
      countryCode: "",
      corporate: "",
      corporateGroup: "",
      passengerProfileImage:"",
      customField2:"",
      customField1:""
    },
    validationSchema: yup.object({
      firstName: yup.string().required("First Name is required").nullable(),
      email: yup
        .string()
        .email("Invalid email format")
        .required("Email is required")
        .nullable(),
      countryCode: yup.string().required("Country Code is required").nullable(),
      mobile: yup
        .string()
        .matches(/^\d{1,15}$/, "Invalid mobile number")
        .required("Mobile is required")
        .nullable(),
        password: yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("New password is required")
        .nullable(),
        passConfirmation: yup
        .string()
        .required("Confirm password is required")
        .oneOf([yup.ref("password"), null], "Passwords must match")
        .nullable(),
      gender: yup.string().required("Gender is required").nullable(),
      country: yup.string().required("Country is required").nullable(),
      passengerProfileImage: yup.string().nullable(),
    }),
    enableReinitialize: true,
    onSubmit: handleAddPassengers,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleToggleNewPasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleToggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  const countryCodes = Object.keys(countryCodeData);

  //Tabs

  return (
    <>
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth={"xl"}
        aria-describedby="dialog-box"
        className={classes.root}
      >
        <DialogTitle>
          <section className={classes.dialogTitleContainer}>
            <Typography variant="body1" className={classes.title}>
              Add Passenger
            </Typography>
            <IconButton aria-label="close" onClick={handleClose}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </section>
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={12}>
              <section className={classes.avatarContainer}>
                <div className={classes.avatarWrapper}>
                  <div className={classes.avatar}>
                    <img
                      src={passengerimage}
                      alt="avatar"
                      className={classes.passenger_img}
                      style={{ objectFit: "cover" }}
                    />
                    <section
                      {...getRootProps()}
                      onClick={open}
                      className={classes.editIcon}
                    >
                      <input {...getInputProps()} />
                      <CameraAltOutlinedIcon />
                    </section>
                    
                {formik.errors.passengerProfileImage && formik.touched.passengerProfileImage && (
                <Typography color="error" variant="caption">
                {formik.errors.passengerProfileImage}
                </Typography>
                )}
                  </div>
                </div>
              </section>
            </Grid>
          </Grid>

          <Grid container>
            <section className={classes.container}>
              <Grid item xs={12} className={classes.detailsContainer}>
                <Grid container className={classes.containerWrapper}>
                  <Grid item xs={12} md={6} lg={6} xl={6}>
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
                          id="firstName"
                          label="First Name"
                          value={formik?.values?.firstName}
                          defaultValue={formik?.values?.firstName}
                          onChange={formik.handleChange}
                          error={
                            formik?.errors?.firstName &&
                            formik?.touched?.firstName
                          }
                          helperText={
                            formik?.errors?.firstName &&
                            formik?.touched?.firstName &&
                            formik?.errors?.firstName
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                        ></TextField>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
                          name="lastName"
                          id="lastName"
                          label="Last Name"
                          value={formik?.values?.lastName}
                          defaultValue={formik?.values?.lastName}
                          onChange={formik?.handleChange}
                          error={
                            formik?.errors?.lastName &&
                            formik?.touched?.lastName
                          }
                          helperText={
                            formik?.errors?.lastName &&
                            formik?.touched?.lastName &&
                            formik?.errors?.lastName
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                        ></TextField>
                      </Grid>
                      <Grid item md={12} lg={12} xl={12}>
                        <Grid container>
                          <Grid
                            item
                            md={4}
                            lg={4}
                            xl={4}
                            className={classes.textFieldWrapper}
                          >
                            <TextField
                              inputProps={{
                              form: {
                                    autocomplete: 'off',
                                  },
                              }}
                              name="countryCode"
                              id="countryCode"
                              label="Country Code"
                              value={formik?.values?.countryCode}
                              defaultValue={formik?.values?.countryCode}
                              onChange={formik?.handleChange}
                              select
                              error={
                                formik?.errors?.countryCode &&
                                formik?.touched?.countryCode
                              }
                              helperText={
                                formik?.errors?.countryCode &&
                                formik?.touched?.countryCode &&
                                formik?.errors?.countryCode
                              }
                              fullWidth
                              variant="outlined"
                              size="small"
                            >
                              {countryCodeData.map((country) => (
                                <MenuItem
                                  key={country.code}
                                  value={country.dial_code}
                                >
                                  {`${country.code} (${country.dial_code})`}
                                </MenuItem>
                              ))}
                            </TextField>
                          </Grid>
                          <Grid
                            item
                            md={8}
                            lg={8}
                            xl={8}
                            className={classes.textFieldWrapper}
                          >
                            <TextField
                              inputProps={{
                              form: {
                                    autocomplete: 'off',
                                  },
                              }}
                              name="mobile"
                              id="mobile"
                              label="Mobile Number"
                              value={formik?.values?.mobile}
                              defaultValue={formik?.values?.mobile}
                              onChange={formik?.handleChange}
                              error={
                                formik?.errors?.mobile &&
                                formik?.touched?.mobile
                              }
                              helperText={
                                formik?.errors?.mobile &&
                                formik?.touched?.mobile &&
                                formik?.errors?.mobile
                              }
                              fullWidth
                              variant="outlined"
                              size="small"
                            ></TextField>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
                          name="email"
                          id="email"
                          label="Email"
                          value={formik?.values?.email}
                          onChange={formik?.handleChange}
                          error={
                            formik?.errors?.email && formik?.touched?.email
                          }
                          helperText={
                            formik?.errors?.email &&
                            formik?.touched?.email &&
                            formik?.errors?.email
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
                          name="password"
                          id="password"
                          autoComplete="new-password"
                          value={formik?.values?.password}
                          onChange={formik?.handleChange}
                          type={showPassword ? "text" : "password"} // Toggle password visibility
                          fullWidth
                          variant="outlined"
                          size="small"
                          label="Password*"
                          error={formik?.errors?.password && formik?.touched?.password}
                          helperText={
                            formik?.errors?.password &&
                            formik?.touched?.password &&
                            formik?.errors?.password
                          }
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle new password visibility"
                                  onClick={handleToggleNewPasswordVisibility}
                                  edge="end"
                                >
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
                          name="passConfirmation"
                          id="passConfirmation"
                          autoComplete="confirm-password"
                          value={formik?.values?.passConfirmation}
                          onChange={(e) => {
                            formik.handleChange(e);
                            formik.validateField("passConfirmation"); // Validate dynamically on each keystroke
                          }}
                          type={showConfirmPassword ? "text" : "password"} // Toggle password visibility
                          fullWidth
                          variant="outlined"
                          size="small"
                          label="Confirm Password*"
                          error={
                            formik?.errors?.passConfirmation && formik?.touched?.passConfirmation
                          }
                          helperText={
                            formik?.errors?.passConfirmation &&
                            formik?.touched?.passConfirmation &&
                            formik?.errors?.passConfirmation
                          }
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle confirm password visibility"
                                  onClick={handleToggleConfirmPasswordVisibility}
                                  edge="end"
                                >
                                  {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
                          name="gender"
                          id="gender"
                          select
                          label="Gender"
                          value={formik?.values?.gender || ""}
                          onChange={formik?.handleChange}
                          error={
                            formik?.errors?.gender && formik?.touched?.gender
                          }
                          helperText={
                            formik?.errors?.gender &&
                            formik?.touched?.gender &&
                            formik?.errors?.gender
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                        >
                          {["male", "female"].map((option) => (
                            <MenuItem key={option} value={option}>
                              {option.charAt(0).toUpperCase() + option.slice(1)}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
                          name="country"
                          id="country"
                          select
                          label="Country"
                          value={formik?.values?.country || ""}
                          onChange={formik?.handleChange}
                          error={
                            formik?.errors?.country && formik?.touched?.country
                          }
                          helperText={
                            formik?.errors?.country &&
                            formik?.touched?.country &&
                            formik?.errors?.country
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                        >
                       {countryCodeData.map((country) => (
                        <MenuItem
                          key={country.code}
                          value={country.name}
                        >
                          {`${country.code} (${country.name})`}
                        </MenuItem>
                        ))}
                        </TextField>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6} xl={6}>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className={classes.textFieldWrapper}
                    >
                      <TextField
                        inputProps={{
                        form: {
                              autocomplete: 'off',
                            },
                        }}
                        name="customField1"
                        id="customField1"
                        label="Custom Field 1"
                        value={formik?.values?.customField1}
                        onChange={formik?.handleChange}
                        error={
                          formik?.errors?.customField1 &&
                          formik?.touched?.customField1
                        }
                        helperText={
                          formik?.errors?.customField1 &&
                          formik?.touched?.customField1 &&
                          formik?.errors?.customField1
                        }
                        fullWidth
                        variant="outlined"
                        size="small"
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className={classes.textFieldWrapper}
                    >
                      <TextField
                        inputProps={{
                        form: {
                              autocomplete: 'off',
                            },
                        }}
                        name="customField2"
                        id="customField2"
                        label="Custom Field 2"
                        value={formik?.values?.customField2}
                        onChange={formik?.handleChange}
                        error={
                          formik?.errors?.customField2 &&
                          formik?.touched?.customField2
                        }
                        helperText={
                          formik?.errors?.customField2 &&
                          formik?.touched?.customField2 &&
                          formik?.errors?.customField2
                        }
                        fullWidth
                        variant="outlined"
                        size="small"
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    xl={12}
                    className={classes.sbtBtnWrapper}
                  >
                    <Button variant="contained" onClick={formik?.handleSubmit}>
                      Add Passenger
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </section>
          </Grid>
        </DialogContent>
        <Divider />
        <DialogActions>
          <section className={classes.dialogActions}>
            <section className={classes.closeBtn}>
              <Button onClick={handleClose}>Close</Button>
            </section>
          </section>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PassengerCreate;
